import React from "react";
import karoLogo from "../assets/images/introduction/karo-logo.svg";

function IntroductionLayout({ children }) {
	return (
		<div className="introduction-layout d-flex flex-column justify-content-between h-100">
			<div className="d-flex justify-content-center mb-300">
				<img src={karoLogo} className="mt-250" alt="karo-logo" />
			</div>

			<div className="children-container flex-fill">{children}</div>
			<div />
		</div>
	);
}

export default IntroductionLayout;
